<main id="content" tabindex="-1" class="m-0 pt-3">

    <div id="home-page-tab-controls" class="d-block d-xl-none mb-3">
        <ul class="nav nav-tabs justify-content-center border-0" role="tablist">
            <li class="nav-item bg-white border-1" role="presentation" (click)="activeNav=1">
                <button [ngClass]="{'active':activeNav==1}" class="nav-link w-100" id="profile-tab" data-bs-toggle="tab" data-bs-target="#announcement-pane" type="button" role="tab" aria-controls="announcement-pane" aria-selected="false">Notices</button>
            </li>
            <li class="nav-item bg-white" role="presentation" (click)="activeNav=2">
                <button [ngClass]="{'active':activeNav==2}" class="nav-link w-100" id="following-tab" data-bs-toggle="tab" data-bs-target="#following-pane" type="button" role="tab" aria-controls="following-pane" aria-selected="false">Following</button>
            </li>
            <li class="nav-item bg-white" role="presentation" (click)="activeNav=3">
                <button [ngClass]="{'active':activeNav==3}" class="nav-link w-100" id="contact-tab" data-bs-toggle="tab" data-bs-target="#events-pane" type="button" role="tab" aria-controls="events-pane" aria-selected="false">Events</button>
            </li>
        </ul>
        @if ( hasMyAnnoucements && activeNav == 1 ) {
            <div class="text-end mt-3 me-2 d-lg-none">
                <a class="btn btn-secondary m-2" [href]="myAnnouncementURL" target="_blank">Post an Announcement</a>
            </div>
        }
    </div>
    <div [ngClass]="{'tab-content': isMobile(), 'border-start' : isMobile(), 'border-end': isMobile()}" class="m-0 py-0 ps-md-3 pe-md-2 row" style="height:100%;">
        <div class="mb-3" [ngClass]="{'tab-pane':isMobile(),'show':isMobile(),'fade':isMobile(),'active':activeNav==1||activeNav==2,'col': !isMobile()}" id="announcement-pane" role="tabpanel">
            <h3 class="ms-3 fw-semibold d-none d-lg-block">Announcements</h3>
            <app-timeline [isMobile]="isMobile()" [activeTab]="activeNav"></app-timeline>
        </div>
        <div class="" [ngClass]="{'p-0': isMobile() ,'tab-pane':isMobile(),'fade':isMobile(),'show':isMobile(),'col': !isMobile(),'active':activeNav==3}" id="events-pane" role="tabpanel">
            <app-user-notifications></app-user-notifications>
            <app-calendar [ngClass]="{'isMobile': isMobile(), 'isDesktop': !isMobile() }" style="top:-{{calendarOffset}}px"></app-calendar>
        </div>
    </div>
</main>
